import inquiryoffer from '@/view/inquiry-offer';

const offer = {
    install:function (Vue) {
        Vue.component('offer',inquiryoffer)
    }
}
export default offer;